import React from 'react'
import { Box, Card, CardContent, CardMedia, Chip, Typography } from '@mui/material'
import moment from 'moment'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css';
import ChipStatus from './ChipStatus/ChipStatus';
import TinyChip from '../chips/tiny-chip';

export default function CardRaffleThirty({
    title,
    description,
    chipTextPromotion,
    slug,
    drawDate,
    image,
    onClick,
    raffle,
    isThirty
}) {
    return (
        <Box onClick={() => onClick(slug)} className="cursor-pointer">
            <Card sx={{ position: "relative", borderRadius: '10px 10px 0 0' }}>
                <LazyLoadImage
                    alt={"Sorteio"}
                    itemProp='image'
                    delayMethod='debounce'
                    fetchPriority='high'
                    style={{
                        maxHeight: 310,
                        minHeight: 310,
                        objectFit: "cover",
                    }}
                    visibleByDefault
                    effect='blur'
                    width={"100%"}
                    src={image}
                    wrapperProps={{
                        // style: { transitionDelay: ".01s" },
                        alt: "Sorteio",
                    }}
                />
                <div style={{
                    position: "absolute",
                    display: "flex",
                    paddingTop: 0,
                    flexDirection: "column",
                    zIndex: 10,
                    left: 0,
                    right: 0,
                    bottom: 0

                }}>
                    <div style={{ width: "100%", height: "100%", background: "linear-gradient(254deg, rgba(29, 86, 255, 0.01) 0px, rgb(0, 0, 0))", top: 0, zIndex: 1, content: "", position: "absolute" }} />
                    <div style={{ zIndex: 100, color: "white", padding: 8, paddingTop: isThirty ? 20 : 0 }}>

                        <div style={{ marginBottom: 10, position: "absolute", top: -15, left: 5 }}>
                            {
                                (chipTextPromotion && raffle.status == "active") && <ChipStatus fontSize={'0.7em'} label={chipTextPromotion} />
                            }
                        </div>
                        <Typography sx={{ margin: 0, padding: 0 }} variant='subtitle1' fontWeight={500}>{title}</Typography>
                        <Typography sx={{ fontSize: 11.5, fontWeight: 400 }}>{description}</Typography>
                        {
                            raffle.status !== "active" &&
                            <TinyChip label="Concluído" style={{ color: "white", backgroundColor: "gray" }} />
                        }
                    </div>
                </div>
            </Card>
        </Box>
    )
}
